<template>
<div class="widget-task-list">

    <div class="task-details" @click="goToPageDetails('/tasks-list?id='+checkProperty( itemData,'_id'))" >
      <!----  <h4>Case Submitted dfsdfdsf</h4>-->
        <p> <a v-if="checkProperty(itemData ,'customId')">{{checkProperty(itemData ,'customId')}} - {{checkProperty( itemData,'title')}} </a></p>
        
        
        <ul> 
            <li v-if="checkProperty( itemData,'createdByName')">Created By:{{checkProperty( itemData,'createdByName')}}  <span v-if="checkProperty( itemData,'createdByRoleName')">({{checkProperty( itemData,'createdByRoleName')}})</span></li>
            <li v-if="checkProperty( itemData,'dueDate')">Due Date: {{checkProperty( itemData,'dueDate') | formatDate}}  <span ></span></li>
            <li v-if="checkProperty( itemData,'assignedToDetails' ,'length')>0"> Assignee: {{checkProperty( itemData['assignedToDetails'][0],'name') }}  <span v-if="checkProperty( itemData['assignedToDetails'][0],'roleName')" >({{checkProperty( itemData['assignedToDetails'][0],'roleName') }})</span></li>
        </ul>
    </div>
    <div class="task-status" >

        <ul >

        <li class="cursor" v-if="checkProperty( itemData,'statusDetails' ,'name')"  v-on:click.stop.prevent="navigateToDetails(itemData ,'TASK_LIST','statusIds' )" >
            <span class="statusspan cursor"
            
               v-bind:class="{
                    'status_created': checkProperty(itemData ,'statusDetails','id') == 1,
                    'status_submited': checkProperty(itemData ,'statusDetails','id') == 2,
                    'status_inProcess': checkProperty(itemData ,'statusDetails','id') == 3,
                    'status_waiting': checkProperty(itemData ,'statusDetails','id') == 4,
                    'status_ready_for_filing': checkProperty(itemData ,'statusDetails','id') == 5,
                    'status_sent_for_signatures': checkProperty(itemData ,'statusDetails','id') == 6,
                    'staus_filed_with_USCIS': checkProperty(itemData ,'statusDetails','id') == 7,
                    'Status_received_by_USCIS': checkProperty(itemData ,'statusDetails','id') == 8,
                    'status_approved': checkProperty(itemData ,'statusDetails','id') == 9,
                    'status_denied': checkProperty(itemData ,'statusDetails','id') == 10,
                    'RFE_Received': ['11',11].indexOf(checkProperty(itemData ,'statusDetails','id')) >-1,
                    'response_to_RFE_Filed': checkProperty(itemData ,'statusDetails','id') == 12,
                    'response_to_RFE_Received': checkProperty(itemData ,'statusDetails','id') == 13,
                    'status_withdrawn': checkProperty(itemData ,'statusDetails','id') == 14,
                    ' ': checkProperty(itemData ,'statusDetails','id') == 15
                  }"
            
            >{{checkProperty( itemData,'statusDetails' ,'name')}}</span>
                
            </li>
            <!---
            <li>
            <a href="#" class="approve-btn"></a>
            </li>
            <li>
            <a href="#" class="close-btn"></a>
            </li>
            <li>
            <a href="#" class="upload-btn"></a>
            </li>
            -->
        </ul>
        <p  v-if="checkProperty( itemData,'updatedOn')" class="task-timing"> {{ checkProperty( itemData,'updatedOn') | timeago}}</p>
    </div>
</div>                  

</template>
<script>
    export default {
     name:'caseByStatus',
     props: {
        widgetData:null,
        itemData:null
     }
    
    
    }
    </script>